import React, {Component} from 'react';
// import PropTypes from 'prop-types';
import {Route} from 'react-router-dom';
import OurProducts from "../../views/ourProducts/OurProducts";
import WhereToBuy from "../../views/whereToBuy/WhereToBuy";
import Contact from "../../views/contact/Contact";
import Header from "../global/header/Header";
// import Footer from "../global/footer/Footer";

/**
 * View Layout
 *
 * @author Mike Rudling <mrudling@wearearchitect.com>
 */
export default class ViewParallaxLayout extends Component {

    /**
     *
     * @type {{}}
     */
    static defaultProps = {
        navList: [
            {
                name: 'Our Products',
                url: '/our-products',
                component: OurProducts,
                // active: false,
            },
            {
                name: 'Where To Buy',
                url: '/where-to-buy',
                component: WhereToBuy,
                // active: false,
            },
            {
                name: 'Contact',
                url: '/contact',
                component: Contact,
                className: 'Contact'
            }
        ]
    };

    /**
     * Prop types
     *
     * @type {{}}
     */
    static propTypes = {
        // component: PropTypes.instanceOf(Component).isRequired
    };

    /**
     * State
     *
     * @type {{}}
     */
    state = {
        headerClassNames: 'Header'
    };

    /**
     * Constructor
     *
     * @param props
     */
    constructor(props) {
        super(props);

        this.setHeaderClassNames = this.setHeaderClassNames.bind(this);

    }

    /**
     * Set header classnames (set by waypoint in ParallaxBasic)
     *
     * @param classNames
     */
    setHeaderClassNames(classNames) {
        this.setState({
            headerClassNames: classNames
        });
    }

    /**
     * Render
     *
     * @returns {*}
     */
    render() {
        const {navList, component: Component, ...rest} = this.props;
        const {headerClassNames} = this.state;

        return (
            <Route {...rest} render={matchProps => (
                <div className="ViewParallaxLayout">
                    {/* <ReactCSSTransitionGroup
                        transitionName="fade"
                        transitionEnterTimeout={500}
                        transitionLeaveTimeout={300}>
                        hello
                    </ReactCSSTransitionGroup> */}

                    <Header navList={navList} {...matchProps}
                            classNames={headerClassNames}/>
                    <Component {...rest} {...matchProps} setHeaderClassNames={this.setHeaderClassNames}/>
                </div>
            )}/>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/layout/ViewParallaxLayout.jsx